export default __webpack_public_path__ + "static/media/studentIcon.3b845e90.svg";